export const mixpanelIdentityPath = {};

export const MIXPANEL_EVENTS = {
  PRIVACY_POLICY: 'privacy_policy_clicked',
  GET_SUPPORT: 'learner_get_support_clicked',
  HELP_SITE: 'help_site_visit_tab_clicked',
  MY_PROFILE_TOGGLED: 'Profile Toggled',
  LEARNER_PROFILE_VIEWED: 'learner_profile_viewed',
  LEARNER_TUTORIAL_CLICKED: 'learner_tutorial_clicked',
  DASHBOARD_INTRO_VIDEO: 'dashboard_intro_video',
  DASHBOARD_WALKTHROUGH: 'dashboard_walkthrough',
  GLOBAL_SEARCH_INTRO: 'global_search_intro',
  LEARNER_DASHBOARD_CLICKED: 'learner_dashboard_clicked',
  HOME_ICON: 'home_icon',
  SITE_NAME: 'site_name',
  GLOBAL_SEARCH_SUGGESTIONS_SHOWN: 'global_search_suggestions_shown',
  GLOBAL_SEARCH_CLICKED: 'global_search_clicked',
  GLOBAL_SEARCH_SUGGESTION_CLICKED: 'global_search_suggestion_clicked',
  MODULE_CLICKED: 'module_clicked',
  SERIES_CLICKED: 'series_clicked',
  GLOBAL_SEARCH_PAGE_TRIGGERED: 'global_search_page_triggered',
  LOGOUT: 'logout',
  REVQ_DASHBOARD_CLICKED: 'revq_dashboard_clicked',
};
